
function _extends() {
  _extends =
    Object.assign ||
    function(target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
const DevicesIcon = forwardRef(function(_ref, ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    rest = _objectWithoutProperties(_ref, ['color', 'size']);

  return /*#__PURE__*/ React.createElement(
    'svg',
    _extends(
      {
        ref: ref,
        width: size,
        height: size,
        viewBox:"0 0 12 12",
        fill: color,
        xmlns: 'http://www.w3.org/2000/svg',
        stroke: 'none',
      },
      rest
    ),
    /*#__PURE__*/ React.createElement('path', {
      d:
        "M10.2528 1.77195C10.2484 1.76726 10.2471 1.76104 10.2425 1.75646C10.2379 1.75189 10.2316 1.7505 10.2268 1.74607C9.10456 0.627886 7.58459 0 6 0C4.41541 0 2.89544 0.627886 1.77316 1.74607C1.76844 1.7505 1.76214 1.75185 1.75752 1.75646C1.75291 1.76108 1.75162 1.76726 1.74723 1.77195C0.910987 2.61184 0.34239 3.68052 0.113202 4.84311C-0.115986 6.00571 0.00450672 7.21012 0.459474 8.30433C0.91444 9.39854 1.68349 10.3335 2.66956 10.9912C3.65563 11.649 4.81453 12 6 12C7.18547 12 8.34437 11.649 9.33044 10.9912C10.3165 10.3335 11.0856 9.39854 11.5405 8.30433C11.9955 7.21012 12.116 6.00571 11.8868 4.84311C11.6576 3.68052 11.089 2.61184 10.2528 1.77195ZM5.99997 10.7953C5.28133 10.7951 4.57195 10.6332 3.92437 10.3218C3.27679 10.0103 2.70761 9.55726 2.25897 8.9961H4.66813C4.83498 9.18463 5.04 9.33559 5.2696 9.43898C5.4992 9.54237 5.74815 9.59584 5.99997 9.59584C6.25179 9.59584 6.50074 9.54237 6.73034 9.43898C6.95994 9.33559 7.16496 9.18463 7.33181 8.9961H9.741C9.29236 9.55726 8.72317 10.0103 8.07559 10.3218C7.428 10.6332 6.71862 10.7951 5.99997 10.7953ZM5.39997 7.79662C5.39997 7.678 5.43516 7.56205 5.50109 7.46342C5.56702 7.36479 5.66072 7.28792 5.77036 7.24253C5.88 7.19714 6.00064 7.18526 6.11702 7.2084C6.23341 7.23154 6.34032 7.28866 6.42423 7.37254C6.50814 7.45641 6.56529 7.56328 6.58844 7.67961C6.61159 7.79595 6.59971 7.91654 6.5543 8.02613C6.50888 8.13572 6.43198 8.22938 6.33331 8.29528C6.23464 8.36118 6.11864 8.39636 5.99997 8.39636C5.84089 8.3962 5.68837 8.33296 5.57588 8.22052C5.46339 8.10808 5.40013 7.95563 5.39997 7.79662ZM10.4461 7.79786L10.4399 7.79662H7.79997C7.79883 7.42575 7.68287 7.06432 7.46801 6.76196C7.25315 6.4596 6.94993 6.23113 6.59997 6.10791V4.19818C6.59997 4.03912 6.53676 3.88657 6.42423 3.7741C6.31171 3.66163 6.1591 3.59844 5.99997 3.59844C5.84084 3.59844 5.68823 3.66163 5.57571 3.7741C5.46318 3.88657 5.39997 4.03912 5.39997 4.19818V6.10791C5.05001 6.23113 4.74679 6.4596 4.53193 6.76196C4.31707 7.06432 4.20111 7.42575 4.19997 7.79662H1.56003L1.55384 7.79786C1.39778 7.41296 1.29282 7.00929 1.24165 6.59714H1.79997C1.9591 6.59714 2.11171 6.53395 2.22424 6.42148C2.33676 6.309 2.39997 6.15646 2.39997 5.9974C2.39997 5.83834 2.33676 5.68579 2.22424 5.57332C2.11171 5.46084 1.9591 5.39766 1.79997 5.39766H1.24165C1.34886 4.54517 1.6845 3.73747 2.2131 3.05994L2.60593 3.45261C2.66164 3.50829 2.72777 3.55246 2.80056 3.5826C2.87335 3.61274 2.95136 3.62825 3.03015 3.62825C3.10893 3.62825 3.18695 3.61273 3.25973 3.5826C3.33252 3.55246 3.39866 3.50829 3.45437 3.4526C3.51008 3.39692 3.55427 3.33081 3.58442 3.25805C3.61456 3.1853 3.63008 3.10732 3.63008 3.02857C3.63008 2.94982 3.61456 2.87184 3.58441 2.79908C3.55426 2.72632 3.51007 2.66022 3.45436 2.60453L3.06157 2.21191C3.73934 1.68372 4.54726 1.34832 5.39997 1.24114V1.79922C5.39997 1.95828 5.46318 2.11083 5.57571 2.2233C5.68823 2.33577 5.84084 2.39896 5.99997 2.39896C6.1591 2.39896 6.31171 2.33577 6.42423 2.2233C6.53676 2.11083 6.59997 1.95828 6.59997 1.79922V1.24114C7.45268 1.34832 8.2606 1.68372 8.93837 2.21191L8.54558 2.60453C8.43307 2.71699 8.36986 2.86952 8.36986 3.02857C8.36986 3.18761 8.43306 3.34014 8.54557 3.4526C8.65808 3.56506 8.81068 3.62824 8.96979 3.62825C9.12891 3.62825 9.2815 3.56507 9.39401 3.45261L9.78684 3.05994C10.3154 3.73747 10.6511 4.54517 10.7583 5.39766H10.2C10.0408 5.39766 9.88823 5.46084 9.7757 5.57332C9.66318 5.68579 9.59997 5.83834 9.59997 5.9974C9.59997 6.15646 9.66318 6.309 9.7757 6.42148C9.88823 6.53395 10.0408 6.59714 10.2 6.59714H10.7583C10.7071 7.00929 10.6022 7.41296 10.4461 7.79786Z",
    })
  );
});
DevicesIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
DevicesIcon.displayName = 'DevicesIcon';
export default DevicesIcon;
